import {Injectable} from "@angular/core";

@Injectable()
export class DelayService {
    load(ms:number): Promise<void>{
        return new Promise(resolve => setTimeout(resolve, ms))
    }
}
